import { post, get, baseURL } from "@/utils/request";

export const getActivityList = () => get(`/activity/getInfo?activityName=recharge_bargain_sales`);

export const rechargeActivity = (params : any) => post(`/activity/rechargeBargainSale`, params);